module.exports = __webpack_public_path__ + "static/media/laptop.6511802a.svg";